export default {
  dbl_model_management_title: '模型管理中心',
  dbl_model_management_create_model: '创建新模型',
  dbl_model_management_search_placeholder: '搜索模型名称,字段名或描述',
  dbl_model_management_name: '名称',
  dbl_model_management_description: '描述',
  dbl_model_management_deployment_stage: '部署阶段',
  dbl_model_management_publish_version: '发布版本',
  dbl_model_management_creator: '创建人',
  dbl_model_management_update_time: '更新时间',
  dbl_model_management_action: '操作',
  dbl_model_management_detail: '详情',
  dbl_model_management_access: '权限',
  dbl_model_management_edit: '编辑',
  dbl_model_management_delete: '删除',
  dbl_model_management_more: '更多',
  dbl_model_management_official_user_guide: '用户指南',
  dbl_model_management_official_documentation: '官方文档',
  dbl_model_management_quick_start: '快速入门',
  dbl_model_management_select_schema: '选择Schema',
  dbl_model_management_select_tables: '选择数据表',
  dbl_model_management_tables: '数据表',
  dbl_model_management_set_up_dimension_metric: '设置维度&指标',
  dbl_model_management_test_publish: '测试 & 发布',
  dbl_model_management_test: '测试',
  dbl_model_management_publish: '发布',
  dbl_model_management_select_database: '选择数据库',
  dbl_model_management_save_all: '保存全部',
  dbl_model_management_draft: '草稿',
  dbl_model_management_tested: '通过测试',
  dbl_model_management_published: '已发布',
  dbl_model_management_published_version: '发布版本',
  dbl_model_management_unpublish: '取消发布',
  dbl_model_management_total: "共 {total} 项",
  dbl_model_management_delete_success: '删除成功',
  dbl_model_management_delete_failed: '删除失败',
  dbl_model_management_publish_success: '发布成功',
  dbl_model_management_publish_failed: '发布失败',
  dbl_model_management_unpublish_success: '取消发布成功',
  dbl_model_management_unpublish_failed: '取消发布失败',
  dbl_model_management_test_success: '测试成功',
  dbl_model_management_test_failed: '测试失败',

  dbl_model_management_create_model_title: '创建新模型',
  dbl_model_management_create_model_previous_step: '上一步',
  dbl_model_management_create_model_next_step: '下一步',
  dbl_model_management_create_model_list: '模型列表',
  dbl_model_management_create_model_save: '保存',
  dbl_model_management_create_model_save_all: '保存全部',
  dbl_model_management_create_model_save_success: '{name} 保存成功',
  dbl_model_management_create_model_save_failed: '{name} 保存失败',
  dbl_model_management_create_model_save_failed_hint:
    '保存草稿失败，请检查 YAML 语法、库表与字段配置后重试。',
  dbl_model_management_create_model_generate_success:
    '{name} YAML 生成成功',
  dbl_model_management_create_model_generate_failed:
    '{name} YAML 生成失败',
  dbl_model_management_create_model_generate_failed_hint:
    'YAML 生成失败，请检查库表与字段配置后重试。',
  dbl_model_management_yaml_generate_detail_title: '生成失败详情',
  dbl_model_management_yaml_save_detail_title: '保存失败详情',
  dbl_model_management_yaml_save_batch_long_summary:
    '保存未成功（{count} 条）。{preview}',
  dbl_model_management_create_model_publish_success: '{name} 发布成功',
  dbl_model_management_create_model_publish_failed: '{name} 发布失败',
  dbl_model_management_create_model_duplicate_name: '名称重复',
  dbl_model_management_create_model_name_error: '支持下划线、英文、数字',
  dbl_model_management_create_model_testing: '测试中...',
  dbl_model_management_create_model_testing_info: '测试正在进行中，请稍候...',
  dbl_model_management_create_model_tested_info: '{successCount} 个模型通过了测试，而 {errorCount} 个没有。',
  dbl_model_management_create_model_tested_info_success: '{successCount} 个模型通过测试',
  dbl_model_management_create_model_tested_info_error: '{errorCount} 个模型未通过测试',
  dbl_model_management_create_model_leave_title: '离开当前页面？',
  dbl_model_management_create_model_leave_des: '当前页面尚未保存，如离开将会丢失所有内容。',
  dbl_model_management_sure_to_delete_model_title: '确定删除模型?',
  dbl_model_management_sure_to_delete_model_message: "删除 {name} ？删除操作无法恢复，请谨慎操作。",
  dbl_model_management_publish_bubble: '请先进行测试',
  dbl_model_management_sure_to_publish_model_title: '发布',
  dbl_model_management_sure_to_publish_model_message: '将发布 {successCount} 个通过模型。{br}{errorCount} 个未通过的模型将保存为草稿，您可以在调整后发布它们。',
  dbl_model_management_leave_model_title: '保存模型？',
  dbl_model_management_leave_model_desc: '模型尚未保存，如离开将会丢失所有内容。',

  dbl_model_management_yaml_test_view_detail: '查看详情',
  dbl_model_management_yaml_test_detail_title: '测试失败详情',
  dbl_model_management_yaml_test_copy: '复制全文',
  dbl_model_management_yaml_test_copy_success: '已复制到剪贴板',
  dbl_model_management_yaml_test_copy_failed: '复制失败，请手动选择文本复制',
  dbl_model_management_yaml_test_error_code: '错误码：{code}',
  dbl_model_management_yaml_test_unnamed_model: '未命名模型',
  dbl_model_management_yaml_test_batch_long_summary:
    '共 {count} 个模型测试未通过。{preview}',
  dbl_model_management_list_refresh_failed:
    '列表或筛选项刷新失败，请稍后重试',
  dbl_model_management_mcp_address: 'MCP服务地址',  
  dbl_model_agent_create_title: '创建新模型',
  dbl_model_agent_create_leave_save_and_leave: '保存并离开',
  dbl_model_agent_edit_title: '编辑模型',
  dbl_model_agent_create_step_select_tables: '选择数据表',
  dbl_model_agent_create_step_field_config: '字段配置',
  dbl_model_agent_create_step_yaml: '生成 YAML',
  dbl_model_agent_create_step_test_publish: '测试 & 发布',
  dbl_model_agent_create_select_fields: '请选择字段',
  dbl_model_agent_create_fields: '字段',
  dbl_model_agent_field_config_need_tables: '请先选择数据库、Schema 与至少一个数据表',
  dbl_model_agent_field_config_empty_catalog: '未返回任何字段，请检查数据表或稍后重试',
  dbl_model_agent_step2_sec_dimensions: '维度 Dimensions',
  dbl_model_agent_step2_sec_measures: '指标 Measures',
  dbl_model_agent_step2_add_dimension: '添加维度',
  dbl_model_agent_step2_add_measure: '添加指标',
  dbl_model_agent_step2_kind_dimension: '维度',
  dbl_model_agent_step2_kind_metric: '指标',
  dbl_model_agent_step2_col_source: '字段名',
  dbl_model_agent_step2_col_kind: '类型',
  dbl_model_agent_step2_col_display: '展示名',
  dbl_model_agent_step2_col_row_select: '选择',
  dbl_model_agent_step2_select_all: '全选',
  dbl_model_agent_step2_col_name_zh: '中文名称',
  dbl_model_agent_step2_col_name_en: '英文名称',
  dbl_model_agent_step2_col_data_type: '数据类型',
  dbl_model_agent_step2_col_agg_type: '指标类型',
  dbl_model_agent_step2_col_sql: 'SQL',
  dbl_model_agent_step2_col_desc: '描述',
  dbl_model_agent_step2_col_sample: '示例值',
  dbl_model_agent_step2_col_dim_summary: '维度汇总值',
  dbl_model_agent_step2_col_dim_table: '维度表',
  dbl_model_agent_step2_col_dim_join_column: '关联字段',
  dbl_model_agent_step2_col_common_query: '常见查询问题',
  dbl_model_agent_step2_placeholder_common_query: '常见查询问题描述',
  dbl_model_agent_step2_inline_dim_heading: '新增自定义维度字段',
  dbl_model_agent_step2_inline_meas_heading: '新增自定义指标字段',
  dbl_model_agent_step2_inline_sql_placeholder_dim: '{CUBE}.field 或表达式',
  dbl_model_agent_step2_inline_sql_placeholder_meas: '{CUBE}.field 或聚合表达式',
  dbl_model_agent_step2_placeholder_dim_display: '自定义维度1（自动）',
  dbl_model_agent_step2_placeholder_meas_display: '自定义指标1（自动）',
  dbl_model_agent_step2_placeholder_sample_dim: '["255","global"]',
  dbl_model_agent_step2_placeholder_dim_summary: '255/global',
  dbl_model_agent_step2_placeholder_dim_table: '维度表',
  dbl_model_agent_step2_placeholder_dim_join: '与主表列对应的维表列',
  dbl_model_agent_step2_placeholder_filters: 'case when...',
  dbl_model_agent_step2_placeholder_name_zh: '中文名称',
  dbl_model_agent_step2_placeholder_name_en: '英文名称',
  dbl_model_agent_step2_placeholder_description: '字段描述',
  dbl_model_agent_step2_option_unset: '不设置',
  dbl_model_agent_field_config_dim_data_type_time: '时间',
  dbl_model_agent_field_config_dim_data_type_string: '文本',
  dbl_model_agent_field_config_dim_data_type_number: '数值',
  dbl_model_agent_field_config_dim_data_type_boolean: '布尔',
  dbl_model_agent_field_config_dim_data_type_geo: '地理',
  dbl_model_agent_field_config_dim_data_type_switch: '枚举',
  dbl_model_agent_field_config_measure_agg_sum: '求和',
  dbl_model_agent_field_config_measure_agg_count: '计数',
  dbl_model_agent_field_config_measure_agg_count_distinct: '去重计数',
  dbl_model_agent_field_config_measure_agg_avg: '平均值',
  dbl_model_agent_field_config_measure_agg_min: '最小值',
  dbl_model_agent_field_config_measure_agg_max: '最大值',
  dbl_model_agent_field_config_measure_agg_number: '数值型',
  dbl_model_agent_step2_option_format_percent: '百分比',
  dbl_model_agent_step2_option_granularity_hour: '小时',
  dbl_model_agent_step2_option_granularity_day: '天',
  dbl_model_agent_step2_option_granularity_month: '月',
  dbl_model_agent_step2_col_format: '格式',
  dbl_model_agent_step2_col_granularity: '数据粒度',
  dbl_model_agent_step2_col_filters: '筛选条件',
  dbl_model_agent_step2_col_actions: '操作',
  dbl_model_agent_step2_remove: '删除',
  dbl_model_agent_step2_custom_tag: '自定义',
  dbl_model_agent_step2_empty_dim: '暂无维度字段，请在上方勾选或添加自定义维度',
  dbl_model_agent_step2_empty_meas: '暂无指标字段，请在上方勾选或添加自定义指标',
  dbl_model_agent_step2_add_dim_title: '新增自定义维度',
  dbl_model_agent_step2_add_meas_title: '新增自定义指标',
  dbl_model_agent_step2_modal_cancel: '取消',
  dbl_model_agent_step2_modal_confirm: '确认添加',
  dbl_model_agent_step2_notify_complete_dim: '请添加完整维度',
  dbl_model_agent_step2_notify_complete_meas: '请添加完整指标',
  dbl_model_agent_step2_notify_required_fields: '请填写完整必填项',
  dbl_model_agent_yaml_file_label: 'YAML 配置文件',
  dbl_model_agent_yaml_status_generating: '正在生成…',
  dbl_model_agent_yaml_status_ready: '生成完成，可自由编辑',
  dbl_model_agent_yaml_status_idle: '暂无内容，请点击「重新生成」',
  dbl_model_agent_yaml_status_error: '生成失败，请检查配置或稍后重试',
  dbl_model_agent_yaml_regenerate: '重新生成',
  dbl_model_agent_yaml_regenerate_confirm:
    '将根据当前已选数据表与字段配置重新生成 YAML，编辑器中未保存的修改将被覆盖。是否继续？',
  dbl_model_agent_summary_tables: '数据表',
  dbl_model_agent_summary_dimensions: '维度',
  dbl_model_agent_summary_measures: '指标',
  dbl_model_agent_summary_count_unit: '{n} 个',
  dbl_model_agent_step4_summary_cube_name: 'Cube 名称',
  dbl_model_agent_step4_summary_source_table: '数据源表',
  dbl_model_agent_step4_summary_dim_fields: '维度字段',
  dbl_model_agent_step4_summary_meas_fields: '指标字段',
  dbl_model_agent_step4_test_bar_label: '测试状态：',
  dbl_model_agent_step4_test_status_idle: '待执行',
  dbl_model_agent_step4_test_status_running: '测试中…',
  dbl_model_agent_step4_test_status_passed: '全部通过 ✓',
  dbl_model_agent_step4_test_status_failed: '存在问题 ×',
  dbl_model_agent_step4_run_all_tests: '▶ 执行全部测试',
  dbl_model_agent_step4_retest: '重新测试',
  dbl_model_agent_step4_test_pass_line: '{name} 通过 ✓',
  dbl_model_agent_step4_test_running_line: '{name} 测试中',
  dbl_model_agent_step4_test_yaml_title: 'YAML 语法校验',
  dbl_model_agent_step4_test_yaml_desc:
    '检查 YAML 格式合法性、必填字段完整性（name、sql_table、data_source）',
  dbl_model_agent_step4_test_sample_title: 'Sample Query 测试',
  dbl_model_agent_step4_test_sample_desc:
    '执行实际 SQL 查询，验证返回数据结构与 Schema 一致',
  dbl_model_agent_step4_sample_skipped: '已跳过 Sample Query 测试',
  dbl_model_agent_step4_sample_time_dimension: '时间维度',
  dbl_model_agent_step4_sample_date_range: '日期范围',
  dbl_model_agent_step4_sample_measures: '测试指标',
  dbl_model_agent_step4_sample_total: '返回行数',
  dbl_model_agent_step4_sample_query_sql: '查询 SQL',
  dbl_model_agent_step4_pub_title: '🎉 全部测试通过，准备发布！',
  dbl_model_agent_step4_pub_desc:
    'Cube 配置已通过所有自动化校验，可安全发布到线上 DataLab 环境',
  dbl_model_agent_step4_publish: '🚀 立即发布上线',
  dbl_model_agent_step4_save_draft: '💾 保存为草稿',
};